import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TIRE_SEARCH_COLUMNS } from "./consts";
import { TireSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import TireRowChild from "./components/TireRowChild";

const TireSearchResults: React.FC<TireSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={TIRE_SEARCH_COLUMNS(t)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        columnsChild={TIRE_SEARCH_COLUMNS(t)}
        CustomTableRowChild={TireRowChild}
      />
    </>
  );
};
export default memo(TireSearchResults);
